import { Directive, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';

@Directive({
  standalone: true,
  selector: 'img, iframe'
})
export class MediaPerformanceDirective implements OnInit {
  private static firstContentMediaClaimed = false;
  private static routerInitialized = false;

  constructor(
    private elementRef: ElementRef<HTMLImageElement | HTMLIFrameElement>,
    private renderer: Renderer2,
    router: Router
  ) {
    if (!MediaPerformanceDirective.routerInitialized) {
      MediaPerformanceDirective.routerInitialized = true;
      router.events.subscribe(event => {
        if (event instanceof NavigationStart) {
          MediaPerformanceDirective.firstContentMediaClaimed = false;
        }
      });
    }
  }

  ngOnInit(): void {
    const element = this.elementRef.nativeElement;
    const isContentMedia = !!element.closest('main');
    const isFirstContentMedia = isContentMedia && !MediaPerformanceDirective.firstContentMediaClaimed;

    if (isFirstContentMedia) {
      MediaPerformanceDirective.firstContentMediaClaimed = true;
      this.renderer.setAttribute(element, 'loading', 'eager');
      this.renderer.setAttribute(element, 'fetchpriority', 'high');
    } else if (!element.hasAttribute('loading')) {
      this.renderer.setAttribute(element, 'loading', 'lazy');
    }

    if (element.tagName === 'IMG' && !element.hasAttribute('decoding')) {
      this.renderer.setAttribute(element, 'decoding', 'async');
    }
  }
}
